export const MOBILE_VIEWPORT_MEDIA_QUERY = "(max-width: 720px)";

/**
 * Inspector-only threshold: phone-sized viewports should use the sheet layout even when
 * pointer detection reports a non-touch device, such as narrow browser preview panes.
 */
export const PHONEISH_VIEWPORT_MEDIA_QUERY = "(max-width: 480px)";
